module.exports = __webpack_public_path__ + "img/home_about_dark.0c89ac92.jpg";